/* eslint-disable react/prop-types */
import React from "react";
import "../../../../css/Recruitment/RadioButton.css"; // Ensure CSS is imported
import "../../../../css/Recruitment/FormField.css"; // Ensure CSS is imported
import { getIsApproved } from "../Utils/UidListener";
import { addUidListener } from "../Utils/UidListener";
import { useState, useEffect } from "react";
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../Utils/submissionListener";

const YesNoRadio = ({ name, value, onChange, error, required, na }) => {
  const [isSubmitted, setIsSubmitted] = useState(getIsSubmitted());

  useEffect(() => {
    // Add a listener to track submission status updates
    const removeListener = addSubmissionListener(setIsSubmitted);
    setIsSubmitted(getIsSubmitted());
    // console.log("Is Submitted Form Field", isSubmitted);
    // console.log(isSubmitted === true ? false : readOnly);
    return () => removeListener(); // Clean up the listener on unmount
  }, [getIsSubmitted()]);

  const handleRadioChange = (e) => {
    if (isSubmitted) return;
    let newValue;
    if (e.target.value === "Yes") {
      newValue = true;
    } else if (e.target.value === "No") {
      newValue = false;
    } else {
      newValue = "N/A"; // Handle N/A value
    }
    onChange({ target: { name, value: newValue } }); // Pass the new value to the parent
  };
  return (
    <div className={`yes-no-radio ${required ? "required" : ""}`}>
      <div className="radio-group">
        <label className="radio-option">
          <input
            type="radio"
            name={name}
            value="Yes"
            checked={value === true} // Select Yes when value is true
            onChange={handleRadioChange}
          />
          <span className="custom-radio"></span>
          <div className="Content">Yes</div>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name={name}
            value="No"
            checked={value === false} // Select No when value is false or null
            onChange={handleRadioChange}
          />
          <span className="custom-radio"></span>{" "}
          <div className="Content">No</div>
        </label>
        {na && (
          <label className="radio-option">
            <input
              type="radio"
              name={name}
              value="N/A"
              checked={value === "N/A"}
              onChange={handleRadioChange}
            />
            <span className="custom-radio"></span>
            <div className="Content"> N/A</div>
          </label>
        )}
      </div>
      {/* {error && <span className="error-message">{error}</span>} */}
    </div>
  );
};

export default YesNoRadio;
